import { render, staticRenderFns } from "./dynamic-project.vue?vue&type=template&id=1efec480&scoped=true&"
import script from "./dynamic-project.vue?vue&type=script&lang=js&"
export * from "./dynamic-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efec480",
  null
  
)

export default component.exports